import { getOfferCategoryTitle } from './getOfferCategoryTitle';
import { getOfferArea } from '../area/getOfferArea';
import { getFloor } from '../floor/getFloor';
import { getFloorsForSuburban } from '../floor/getFloorsForSuburban';
import { getBedroomCount } from '../bedroom/getBedroomCount';
import { IOffer } from '../../../types/offer';
import { getLandAreaTitle } from '../suburban/getLandAreaTitle';
import { getLandStatus } from '../suburban/getLandStatus';

export function getOfferName(offer: IOffer) {
  return [
    getOfferCategoryTitle,
    getOfferArea,
    getLandAreaTitle,
    getLandStatus,
    getFloor,
    getFloorsForSuburban,
    getBedroomCount,
  ]
    .map(fn => fn(offer))
    .filter(Boolean)
    .join(', ');
}
